import { makeStyles } from '@material-ui/core';
import { colorSet } from '@components/Provider';

export const useStyles = makeStyles((theme) => ({
  inputContainer: {
    marginTop: '12px',
    flexWrap: 'nowrap'
  },
  emailContainer: {
    width: 460,
    flexWrap: 'nowrap'
  },
  emailContainer_authorized: {
    width: '100%'
  },
  authorizationButton: {
    height: 42,
    width: 124,
    maxWidth: 124,
    marginLeft: 16,
    '&.Mui-disabled': {
      border: `1px solid ${colorSet.gray400}`,
      '& span': {
        color: `1px solid ${colorSet.gray400}`
      }
    },
    [theme.breakpoints.down('xs')]: {
      minWidth: '100px !important',
      width: 100
    }
  },
  authInput: (props: { emailAuthState: boolean }) => ({
    '& .MuiOutlinedInput-root': {
      height: 42
    },
    '& .MuiInputBase-root.Mui-disabled': {
      ...theme.typography.body2,
      color: colorSet.gray500,
      backgroundColor: colorSet.gray100
    },
    '& .MuiFormHelperText-root.Mui-error': {
      color: colorSet.errorMain
    },
    '& .MuiFormHelperText-root': {
      color: props.emailAuthState ? theme.palette.primary.main : undefined
    }
  }),
  authInputNotchedOutline: {
    border: `1px solid ${colorSet.gray400}`
  },
  authInputPlaceholder: {
    '&::placeholder': {
      ...theme.typography.body2,
      color: '#939FA5'
    }
  }
}));
